<template>
  <div class="cs-page">

    <!-- Hero -->
    <div class="cs-hero">
      <div class="d-flex align-center" style="gap:14px;">
        <v-avatar color="rgba(255,255,255,0.15)" size="46">
          <v-icon color="white" size="26">mdi-file-chart-outline</v-icon>
        </v-avatar>
        <div>
          <div class="cs-hero__title">Consolidado de Facturación</div>
          <div class="cs-hero__sub">Comparación SIAT vs sistema interno por período y NIT</div>
        </div>
      </div>
      <v-chip small color="rgba(255,255,255,0.15)" dark>
        <v-icon left small>mdi-bank-outline</v-icon> Contabilidad
      </v-chip>
    </div>

    <div class="cs-body">

      <!-- Filtros -->
      <v-card outlined class="cs-filters-card mb-4">
        <v-card-title class="cs-filters-card__title py-2 px-4">
          <v-icon small color="indigo darken-2" class="mr-1">mdi-filter-outline</v-icon>
          Parámetros de consulta
        </v-card-title>
        <v-card-text class="pt-3 pb-3 px-4">
          <v-row dense align="center">
            <v-col cols="12" sm="3">
              <v-select label="Mes" v-model="input.mes" :items="meses" :item-value="'id'"
                outlined hide-details dense prepend-inner-icon="mdi-calendar-month-outline" />
            </v-col>
            <v-col cols="12" sm="2">
              <v-select label="Gestión" v-model="input.gestion" :items="gestiones"
                outlined hide-details dense prepend-inner-icon="mdi-calendar-range" />
            </v-col>
            <v-col cols="12" sm="4">
              <v-select label="NIT / Sucursal" v-model="input.nit" :items="nits"
                item-text="xtext" return-object outlined hide-details dense
                prepend-inner-icon="mdi-office-building" />
            </v-col>
            <v-col cols="12" sm="3" class="d-flex align-center" style="gap:8px;">
              <v-btn color="indigo darken-1" dark depressed @click="buscar" :loading="loading">
                <v-icon left small>mdi-magnify</v-icon> Buscar
              </v-btn>
              <v-btn color="teal darken-1" dark depressed @click="subir">
                <v-icon left small>mdi-upload</v-icon> Subir .csv
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <!-- Tabs -->
      <v-card outlined class="cs-tabs-card">
        <v-tabs v-model="tab" @change="tab_cmabiado"
          background-color="indigo darken-1" dark
          slider-color="amber" active-class="cs-tab--active">
          <v-tab>
            <v-icon left small>mdi-cloud-download-outline</v-icon>
            Consolidado SIAT
          </v-tab>
          <v-tab>
            <v-icon left small>mdi-database-outline</v-icon>
            Consolidado Ventas
          </v-tab>
        </v-tabs>
        <v-divider />
        <v-tabs-items v-model="tab">
          <v-tab-item>
            <ConsolidadoSiat ref="refConsolidadoSiat" />
          </v-tab-item>
          <v-tab-item>
            <ConsolidadoSiat2 ref="refConsolidadoVentas" />
          </v-tab-item>
        </v-tabs-items>
      </v-card>

    </div>

    <Subircsv ref="refSubircsv" v-on:cargado="buscar" />
  </div>
</template>

<script>
import {meses,getGestiones,getSucursalesBySede} from './utils.ts'
import Subircsv from './subir_csv.vue'
import ConsolidadoSiat from './consolidado_siat.vue' 
import ConsolidadoSiat2 from './consolidado_sistema.vue' 

export default {
    components:{ Subircsv,ConsolidadoSiat,ConsolidadoSiat2 },
    data: () => ({
        meses, 
        loading: false,
        gestiones: [],
        nits:[], 
        tab: null,
        input: {
            mes: null,
            gestion: null,
            nit: {},
        }
    }),
    methods:{
        async get_gestiones(){
            this.loading = true;
            this.gestiones = await getGestiones(this);
            const { xxxnits } = await getSucursalesBySede(this);
            // window.console.log('----->>', xxxnits, data);
            this.nits = xxxnits;
            this.loading = false;
        },
        buscar(){
            this.tab_cmabiado(this.tab);
            
        },
        async tab_cmabiado(e){ 
            if(!this.isvalido()){
                return
            } 

            await new Promise(resolve => setTimeout(resolve, 350));

            if(e==0 && this.$refs.refConsolidadoSiat){
                this.$refs.refConsolidadoSiat.get_datos('sin',this.input.mes,this.input.gestion,this.input.nit)
            }else if(e==1 && this.$refs.refConsolidadoVentas){
                this.$refs.refConsolidadoVentas.get_datos('sistema',this.input.mes,this.input.gestion,this.input.nit)
            }
        },
        isvalido(){
            if(!this.input.mes){
                this.$root.$notify.show(`Seleccione el mes`, {color:'red',x: 'right',});
                return false
            }
            if(!this.input.gestion){
                this.$root.$notify.show(`Seleccione la gestion`, {color:'red',x: 'right',});
                return false
            }
            if(!this.input.nit || !this.input.nit.apikey){
                this.$root.$notify.show(`Seleccione el nit`, {color:'red',x: 'right',});
                return false
            }
            return true;
        },
        subir(){
            if(!this.isvalido()){
                return
            } 
            this.$refs.refSubircsv.openmodal(this.input, this.meses,this.gestiones);
        }
    },
    mounted(){
        this.get_gestiones()
    }
}

</script>

<style scoped>
.cs-page { min-height: 100vh; background: #f5f7fa; }

.cs-hero {
  background: linear-gradient(120deg, #1a237e 0%, #283593 50%, #1565c0 100%);
  padding: 20px 28px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
}
.cs-hero__title { font-size: 1.15rem; font-weight: 700; color: #fff; letter-spacing: 0.02em; }
.cs-hero__sub   { font-size: 0.78rem; color: rgba(255,255,255,0.65); margin-top: 2px; }

.cs-body { padding: 20px 24px; }

.cs-filters-card { border-radius: 10px !important; border-color: #e3e8f0 !important; }
.cs-filters-card__title {
  font-size: 0.8rem !important; font-weight: 700 !important;
  color: #283593; letter-spacing: 0.02em; border-bottom: 1px solid #e8edf7;
}

.cs-tabs-card { border-radius: 10px !important; border-color: #e3e8f0 !important; overflow: hidden; }
.cs-tab--active { font-weight: 700 !important; }
</style>
